export default "__VITE_ASSET__CGpxCVNG__"